import React from 'react';
import { Link, useNavigate } from 'react-router-dom'; // 导入 useNavigate
import { useAuth } from '../context/AuthContext'; // 导入 AuthContext
import { useTranslation } from 'react-i18next';
// import '../styles/Navbar.css';

const Footer = () => {
  const { user, logout, isTokenValid } = useAuth(); // 获取用户信息、登出功能和token有效性
  const navigate = useNavigate(); // 路由跳转
  const { t } = useTranslation();

  const handleLogout = () => {
    logout(); // 清除用户信息
    navigate('/'); // 跳转到主页
  };

  // 检查用户是否真正登录（有用户信息且token有效）
  const isLoggedIn = user && isTokenValid;

  return (
    <footer className="footer">
      <nav>
        <Link to="/">{t('nav.home')}</Link>
        <Link to="/technicians">{t('nav.technicians')}</Link>
        <Link to="/services/到店按摩">{t('nav.services')}</Link>
        
        {/* 只有登录用户才显示的链接 */}
        {isLoggedIn ? (
          <>
            <Link to="/appointments">{t('nav.appointments')}</Link>
            <Link to={`/users/${user.id}`}>{t('nav.personalCenter')}</Link>
          </>
        ) : (
          <Link to="/login">{t('nav.login')}</Link>
        )}
      </nav>
    </footer>
  );
};

export default Footer;
